import { getLocale } from '../store/services/http-common';

/**
 * Ensure every fetch() call sends the current UI locale to the API.
 * Many Redux slices use raw fetch without getLanguageHeaders().
 */
export function installFetchLanguageHeaders() {
  if (typeof window === 'undefined' || window.__dentristFetchLocalePatched) {
    return;
  }

  window.__dentristFetchLocalePatched = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    const locale = getLocale();
    const headers = new Headers(init.headers || {});

    if (!headers.has('X-Language')) {
      headers.set('X-Language', locale);
    }

    if (!headers.has('Accept-Language')) {
      headers.set('Accept-Language', locale);
    }

    return originalFetch(input, { ...init, headers });
  };
}
